module.exports = __webpack_public_path__ + "static/media/Lec2.6517ec68.png";